// App.js — extracted from App.js (behaviour-preserving split).
import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { OfflineBanner } from "@/components/OfflineBanner";
import { ThemeProvider } from "@/app/core";
import { DeviceBootstrap, DeviceRoot, FloatingSettingsButton, SeasonalThemeApplier } from "@/app/DeviceBootstrap";
import { AppErrorBoundary } from "@/app/AppErrorBoundary";
import { ApkUpdateWatcher, DesktopUpdateWatcher, MorningUpdateSplash, OtaUpdateWatcher, PwaUpdateToast } from "@/app/UpdateWatchers";
import { CoordinatorElectionGate } from "@/app/CoordinatorElectionGate";
import { InstallPage } from "@/pages/InstallPage";
import { InstallSetupPage } from "@/pages/InstallSetupPage";
import { GatedSettingsPage } from "@/pages/SettingsPage";
import { CustomerMenuPage } from "@/pages/CustomerMenuPage";
import { OrderStatusPage } from "@/pages/OrderStatusPage";
import { RoleLoginPage } from "@/pages/RoleLoginPage";
import { StaffDashboardPage } from "@/pages/StaffDashboardPage";
import { OwnerDashboardPage } from "@/pages/OwnerDashboardPage";
import { KitchenDashboardPage } from "@/pages/stations/KitchenDashboardPage";
import { BarDashboardPage } from "@/pages/stations/BarDashboardPage";
import { RunnerDashboardPage } from "@/pages/stations/RunnerDashboardPage";
import { RetailDashboardPage } from "@/pages/stations/RetailDashboardPage";
import { AdminBusinessDetailPage, AdminDashboardPage, AdminLoginPage } from "@/pages/admin/AdminPages";


function TagRedirectPage() {
  const { tagCode } = useParams();
  return <Navigate to={`/menu?tag=${encodeURIComponent(tagCode || "")}`} replace />;
}

function AppShell() {
  return (
    <ThemeProvider defaultTheme="light">
      <SeasonalThemeApplier />
      <BrowserRouter>
        <AppErrorBoundary>
          <div className="min-h-screen bg-background text-foreground">
            <DeviceBootstrap />
            <OfflineBanner />
            <PwaUpdateToast />
            <ApkUpdateWatcher />
            <DesktopUpdateWatcher />
            <OtaUpdateWatcher />
            <FloatingSettingsButton />
            <MorningUpdateSplash />
            <CoordinatorElectionGate />
            <Routes>
            <Route path="/" element={<DeviceRoot />} />
            <Route path="/install" element={<InstallPage />} />
            <Route path="/install/setup" element={<InstallSetupPage />} />
            <Route path="/settings" element={<GatedSettingsPage />} />
            <Route path="/menu" element={<CustomerMenuPage />} />
            <Route path="/t/:tagCode" element={<TagRedirectPage />} />
            <Route path="/order/:orderId" element={<OrderStatusPage />} />
            <Route path="/staff" element={<RoleLoginPage key="staff" role="staff" />} />
            <Route path="/staff/dashboard" element={<StaffDashboardPage />} />
            <Route path="/owner" element={<RoleLoginPage key="owner" role="owner" />} />
            <Route path="/owner/dashboard" element={<OwnerDashboardPage />} />
            <Route path="/kitchen" element={<RoleLoginPage key="kitchen" role="kitchen" />} />
            <Route path="/kitchen/dashboard" element={<KitchenDashboardPage />} />
            <Route path="/bar" element={<RoleLoginPage key="bar" role="bar" />} />
            <Route path="/bar/dashboard" element={<BarDashboardPage />} />
            <Route path="/runner" element={<RoleLoginPage key="runner" role="staff" runnerMode />} />
            <Route path="/runner/dashboard" element={<RunnerDashboardPage />} />
            <Route path="/retail" element={<RoleLoginPage key="retail" role="retail" />} />
            <Route path="/retail/dashboard" element={<RetailDashboardPage />} />
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/admin/businesses/:businessId" element={<AdminBusinessDetailPage />} />
            <Route path="*" element={<Navigate to="/menu" replace />} />
          </Routes>
          </div>
        </AppErrorBoundary>
        <Toaster position="top-center" />
      </BrowserRouter>
    </ThemeProvider>
  );
}

function App() {
  return <AppShell />;
}

export default App;
